"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var F_PlainDate_Elapsed_1 = require("./F_PlainDate_Elapsed");
var F_PlainDate_Is_1 = __importDefault(require("./F_PlainDate_Is"));
var F_PlainDate_Add_1 = __importDefault(require("./F_PlainDate_Add"));
var java_js_dateformat_1 = require("java-js-dateformat");
var F_PlainDate = /** @class */ (function () {
    /** @hidden */
    function F_PlainDate(plainDate) {
        this.plainDate = plainDate;
        this.is = new F_PlainDate_Is_1.default(this.plainDate);
        this.add = new F_PlainDate_Add_1.default(this.plainDate);
        this.subtract = new F_PlainDate_Add_1.default(this.plainDate, -1);
        this.elapsed = new F_PlainDate_Elapsed_1.F_PlainDate_Elapsed(this.plainDate);
        this.toIso = this.toIso.bind(this);
        this.format = this.format.bind(this);
        this.getJsDate = this.getJsDate.bind(this);
    }
    /** @hidden */
    F_PlainDate.prototype._getTemporalPlainDate = function () {
        return this.plainDate;
    };
    /** @hidden */
    F_PlainDate.prototype.getJsDate = function () {
        /**
        by passing mm-dd-yyyy
        we avoid timezone adjustment/offset, resulting in the wrong day e.g. when we toString, or format.
        See https://stackoverflow.com/questions/7556591/is-the-javascript-date-object-always-one-day-off
     */
        var mdyString = "".concat(String(this.plainDate.month).padStart(2, '0'), "-").concat(String(this.plainDate.day).padStart(2, '0'), "-").concat(String(this.plainDate.year).padStart(4, '0'));
        return new Date(mdyString);
    };
    F_PlainDate.prototype.format = function (pattern, locale) {
        var date = this.getJsDate();
        return java_js_dateformat_1.Formatters.formatLocalDate(date.getFullYear(), date.getMonth() + 1, date.getDate(), pattern, locale);
    };
    F_PlainDate.prototype.toIso = function () {
        return this.plainDate.toString();
    };
    return F_PlainDate;
}());
exports.default = F_PlainDate;
//# sourceMappingURL=F_PlainDate.js.map